var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sync 1",
    clipPath: "url(#clip0_10553_4579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 3.37504V6.9375C20 7.62785 19.4404 8.1875 18.75 8.1875H15.1875C14.4972 8.1875 13.9375 7.62785 13.9375 6.9375C13.9375 6.24715 14.4972 5.6875 15.1875 5.6875H16.1426C14.7623 3.70918 12.5003 2.5 10 2.5C6.8891 2.5 4.14656 4.3716 3.01305 7.26809C2.76141 7.91098 2.03625 8.22812 1.39344 7.97656C0.750547 7.72496 0.433359 6.99984 0.684961 6.35699C1.40992 4.50453 2.65945 2.92316 4.29848 1.78383C5.97727 0.616836 7.94879 0 10 0C12.0512 0 14.0227 0.616836 15.7015 1.78379C16.3686 2.24746 16.9711 2.78441 17.5 3.38301V3.37508C17.5 2.68473 18.0596 2.12508 18.75 2.12508C19.4404 2.12508 20 2.68469 20 3.37504ZM18.6066 12.0235C17.9637 11.7718 17.2386 12.0891 16.987 12.732C15.8534 15.6284 13.1109 17.5 10 17.5C7.55285 17.5 5.33383 16.3416 3.94648 14.4375H4.81246C5.50281 14.4375 6.06246 13.8779 6.06246 13.1875C6.06246 12.4971 5.50281 11.9375 4.81246 11.9375H1.25C0.559648 11.9375 0 12.4971 0 13.1875V16.75C0 17.4404 0.559648 18 1.25 18C1.94035 18 2.5 17.4404 2.5 16.75V16.617C3.02891 17.2156 3.63145 17.7525 4.29848 18.2162C5.97727 19.3832 7.94879 20 10 20C12.0512 20 14.0227 19.3832 15.7015 18.2162C17.3405 17.0769 18.5901 15.4955 19.315 13.643C19.5666 13.0002 19.2495 12.2751 18.6066 12.0235Z",
    fill: "#FFC877"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10553_4579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.8e29f8fe49890f31cb598d5ef1acf822.svg";
export { ForwardRef as ReactComponent };